'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "NavCategory", {
    enumerable: true,
    get: function() {
        return NavCategory;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useNavCategory = require("./useNavCategory");
const _renderNavCategory = require("./renderNavCategory");
const _useNavCategoryContextValues_unstable = require("../useNavCategoryContextValues_unstable");
const NavCategory = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useNavCategory.useNavCategory_unstable)(props, ref);
    const contextValues = (0, _useNavCategoryContextValues_unstable.useNavCategoryContextValues_unstable)(state);
    return (0, _renderNavCategory.renderNavCategory_unstable)(state, contextValues);
});
NavCategory.displayName = 'NavCategory';
